import { render, staticRenderFns } from "./appointmentdetail.vue?vue&type=template&id=cf0876c0&"
import script from "./appointmentdetail.vue?vue&type=script&lang=js&"
export * from "./appointmentdetail.vue?vue&type=script&lang=js&"
import style0 from "./appointmentdetail.vue?vue&type=style&index=0&id=cf0876c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports